import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from '../models/user';
import { Token } from '../models/token';
import { RefreshToken } from '../models/refresh-token';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) { }


  createUser(user: User) {
    return this.http.post(`${environment.apiroot}/auth/register/`, user);
  }

  updateUser(username:string, cognitoId:string) {
    return this.http.patch(`${environment.apiroot}/auth/confirmation/${username}`, cognitoId);
  }

  insertToken(token: Token) {
    return this.http.post(`${environment.apiroot}/auth/token/`, token);
  }

  refreshToken(refreshToken:RefreshToken) {
    return this.http.post(`${environment.apiroot}/auth/refresh-token/`, refreshToken);
  }

  deleteToken(token:string) {
    return this.http.delete(`${environment.apiroot}/auth/token/${token}`);
  }


}
